import { useUser } from '../Contexts/UserContext';
import ClientProperty from '../Screens/Client/Property';
import Property from '../Screens/Tenant/Property';

export default function EnergyBills() {
    const { type } = useUser();

    return (
        <>
            {type == 'client' && <ClientProperty />}
            {type == 'tenant' && <Property />}
        </>
    );
}